var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("Template" + _vm.currentTemplate),{tag:"component",attrs:{"page":_vm.page,"template":_vm.currentTemplate}})}
var staticRenderFns = []

export { render, staticRenderFns }